import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import Table from "../../components/table/Table";
import Icon from "../../components/icon/Icon";
import SegnalazioniServices from "../../services/SegnalazioniServices";
import OggettiUtili from "../../utils/OggettiUtili";
import Spinner from "../../components/spinner/Spinner"
import {states} from '../Wizard/States/States';
import SessioneUtente from "../../sessionManager/SessioneUtente";
import DizionariService from "../../services/DizionariService";
import Ruoli from "../../utils/Ruoli.json";
import Utils from "../../utils/Utils";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import history from "../../utils/History";
import globals from "../../config/appconfig";

class Home extends Component {

    state = {
        rows: [],
        totalElements: 0,
        cols: [],
        loading: false,
        page: 0,
        totalPages: 0,
        size: 10,
        rowsLIS: [],
        totalElementsLIS: 0,
        colsLIS: [],
        pageLIS: 0,
        totalPagesLIS: 0,
        sizeLIS: 10,
        notifiche: []
    }

    constructor(props) {
        super(props);
        this.buildParams = this.buildParams.bind(this)
        this.controllaUlss = this.controllaUlss.bind(this)
        this.changePageTable = this.changePageTable.bind(this)
        this.changePaginationTable = this.changePaginationTable.bind(this)
         this.changePageTableLIS = this.changePageTableLIS.bind(this)
        this.changePaginationTableLIS = this.changePaginationTableLIS.bind(this)
    }

    cols = [
        {
            key: "idSegnalazione",
            name: "Tables.Home.id",
            sortDirection: "none",
            tipo: "link",
            path: "/wizardSegnalazione",
            nomeParametro: "idSegnalazione",
            state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
        },
        {key: "malattia", name: "Tables.Home.malattia", sortDirection: "none"},
        {key: "paziente", name: "Tables.Home.paziente", sortDirection: "none"},
        {key: "utenteInserimento", name: "Tables.Home.inserUser", sortDirection: "none"},
        {
            key: "ulssAppartenenza",
            name: "Tables.Home.ulssApp",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {
            key: "ulssSegnalazione",
            name: "Tables.Home.ulssSegn",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {key: "dataSegnalazione", name: "Tables.Home.data", sortDirection: "none", tipo: "data"},
        {
            key: "statoSegnalazione", name: "Tables.Home.stato", sortDirection: "none", tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        },
        {key: "scadenza", name: "Tables.Home.scadenza", sortDirection: "none"},
        {key: "timestampCompilazione", name: "Tables.Home.dataCompilazione", sortDirection: "none", tipo: "data"}
    ]

     colsLIS = [
        
        {key: "malattia", name: "Tables.HomeLIS.malattia", sortDirection: "none"},
        {key: "paziente", name: "Tables.HomeLIS.paziente", sortDirection: "none"},
        {key: "utenteInserimento", name: "Tables.HomeLIS.inserUser", sortDirection: "none"},
        {
            key: "ulssAppartenenza",
            name: "Tables.HomeLIS.ulssApp",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {
            key: "ulssSegnalazione",
            name: "Tables.HomeLIS.ulssSegn",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {key: "dataSegnalazione", name: "Tables.HomeLIS.data", sortDirection: "none", tipo: "data"},
        {
            key: "statoSegnalazione", name: "Tables.HomeLIS.stato", sortDirection: "none", tipo: "pallino",
            oggetto: OggettiUtili.statoSegnalazione
        },
        {key: "scadenza", name: "Tables.HomeLIS.scadenza", sortDirection: "none"},
        {key: "timestampCompilazione", name: "Tables.HomeLIS.dataCompilazione", sortDirection: "none", tipo: "data"},
        {
            key: "id",
            
            tipo: "linkButton",
            path: "/wizardSegnalazione",
            nomeParametro: "Prendere in carico",
            
        }
    ]

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this)
        DizionariService.getMalattie().then(() => {
            let segnalazioniRequestParam = {
                ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione ||
                    SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione ?
                    SessioneUtente.getInstance().ulss : null,
                size: this.state.size,
                home: true
            }
            this.getSegnalazioni(Utils.removeEmptyValueFromObject(segnalazioniRequestParam));
            this.getSegnalazioniLIS(Utils.removeEmptyValueFromObject(segnalazioniRequestParam));
            this.getMalattiePremal();
            DizionariService.getMalattiePerFocolai();
            DizionariService.getProvince();
            DizionariService.getNazioni();
            DizionariService.getAulss();
            DizionariService.getSiglaProvince();
            DizionariService.getAulssPerComuni();
            DizionariService.getComuni();
            DizionariService.getComuniPerAulss();
            DizionariService.getStruttureAndStabilimenti();
            DizionariService.getReparti();
            DizionariService.getMalattieUtenteLaboratorio();
            SegnalazioniServices.getNotifica(SessioneUtente.getInstance().codiceFiscale).then((data) => {
                let dati = data.data
                let lista = [];
                for (let i = 0; i < dati.length; i++) {
                    let descrizioneNotifica =
                        {
                            url: "/wizardSegnalazione",
                            malattia: dati[i].malattia,
                            utenteInserimento: dati[i].utenteInserimento,
                            nomeParametro: dati[i].idSegnalazione,
                            label: dati[i].giorniRimanenti,
                            label2: "È necessario completare la compilazione per poter procedere alla validazione"
                        }

                    lista.push(descrizioneNotifica);

                }

                lista.sort(Utils.SorterObjectDesc)
                this.props.setStatePadre({notifiche: lista})
            })
        });

    }

    getMalattiePremal() {
        SegnalazioniServices.getMalattiePremal().then((data) => {
            let malattiePremalGiornaliero = data.data[0].split(",")
            let malattiePremalSettimanale = data.data[1].split(",")
            let malattiePremal = {
                "giornaliero" : malattiePremalGiornaliero,
                "settimanale" : malattiePremalSettimanale
            }
            sessionStorage.setItem("malattiePremal", JSON.stringify(malattiePremal))
        }).catch(() => {
            console.log("[ERROR] Get Malattie Premal to SessionStorage")
        });
    }

    getSegnalazioni(segnalazioniRequestParam) {
        this.setState({loading: true})
        SegnalazioniServices.getSegnalazioni(segnalazioniRequestParam).then((data) => {
            let res = SegnalazioniServices.mapGetSegnalazioni(data);

            let newState = {
                rows: res,
                loading: false,
                totalPages: data.data.totalPages,
                totalElements: data.data.totalElements
            }

            if (segnalazioniRequestParam.size && segnalazioniRequestParam.size !== this.state.size) {
                newState["size"] = segnalazioniRequestParam.size
            }

            if ((segnalazioniRequestParam.page || segnalazioniRequestParam.page === 0) && segnalazioniRequestParam.page !== this.state.page) {
                newState["page"] = segnalazioniRequestParam.page
            }

            this.setState(newState);

        }).catch(() => {
            let newState = {rows: [], totalElements: 0, loading: false, page: 0};

            newState["size"] = this.state.size

            if ((segnalazioniRequestParam.page || segnalazioniRequestParam.page === 0) && segnalazioniRequestParam.page !== this.state.page) {
                newState["page"] = segnalazioniRequestParam.page
            }

            this.setState(newState);
        })
    }

    getSegnalazioniLIS(segnalazioniRequestParam) {
        this.setState({loading: true})
        SegnalazioniServices.getSegnalazioniLIS(segnalazioniRequestParam).then((data) => {
            let res = SegnalazioniServices.mapGetSegnalazioniLIS(data);

            let newState = {
                rowsLIS: res,
                loading: false,
                totalPagesLIS: data.data.totalPages,
                totalElementsLIS: data.data.totalElements
            }

            if (segnalazioniRequestParam.size && segnalazioniRequestParam.size !== this.state.sizeLIS) {
                newState["sizeLIS"] = segnalazioniRequestParam.size
            }

            if ((segnalazioniRequestParam.page|| segnalazioniRequestParam.page === 0) && segnalazioniRequestParam.page !== this.state.pageLIS) {
                newState["pageLIS"] = segnalazioniRequestParam.page
            }

            this.setState(newState);

        }).catch(() => {
            let newState = {rowsLIS: [], totalElements: 0, loading: false, pageLIS: 0};

            newState["size"] = this.state.size

            if ((segnalazioniRequestParam.page || segnalazioniRequestParam.page === 0) && segnalazioniRequestParam.page !== this.state.page) {
                newState["pageLIS"] = segnalazioniRequestParam.page
            }

            this.setState(newState);
        })
    }

    controllaUlss() {
        if (SessioneUtente.getInstance() && OggettiUtili.UlssImg[SessioneUtente.getInstance().ulss]) {
            return OggettiUtili.UlssImg[SessioneUtente.getInstance().ulss].descrizione
        } else {
            return false
        }
    }

    changePageTable(sort, direction, page, size) {

        let params = this.buildParams(sort, direction, page, size);

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }

        params.home = true

        this.getSegnalazioni(params)

    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);

        if (size != null)
            params.size = size

        params.home = true

        this.getSegnalazioni(params)

    }

     changePageTableLIS(sort, direction, page, size) {

        let params = this.buildParams(sort, direction, page, size);

        if (size != null) {
            if (size !== this.state.sizeLIS) {
                params.size = this.state.sizeLIS
            } else {
                params.size = size
            }
        }

        params.home = true

        this.getSegnalazioniLIS(params)

    }

    changePaginationTableLIS(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);

        if (size != null)
            params.size= size

        params.home = true

        this.getSegnalazioniLIS(params)

    }

    inserisciNuova(row) {
            let path = "/wizardSegnalazione";
    
            SegnalazioniServices.getSingolaSegnalazioneLIS(row.id).then((data) => {
        // Salva i dati necessari nello storage per passarli alla nuova pagina
                history.push({
                    pathname: path,
                   
                    malattia: data.data.infoLaboratorio.codiceSirmi.split('-')[0],
                    nomePaziente: data.data.anagNotificationLis.nome,
                    cognomePaziente: data.data.anagNotificationLis.cognome,
                    codiceFiscale: data.data.anagNotificationLis.cfPaziente,
                    stp: data.data.anagNotificationLis.stp,
                    ulssSegnalazione: data.data.infoLaboratorio.ulss,
                    comuneSegnalazione:data.data.infoLaboratorio.istatComuneLaboratorio,
                    dataSegnalazione:Utils.transformTimeStampForFrontend(data.data.dataSegnalazione),
                    dataDiNascita:Utils.transformTimeStampForFrontend(data.data.anagNotificationLis.dttNascita),
                    sesso:data.data.anagNotificationLis.sesso,
                    comuneResidenza:data.data.anagNotificationLis.cittaResidenza?data.data.anagNotificationLis.cittaResidenza:data.data.anagNotificationLis.paeseResidenza,
                    indirizzoResidenza: data.data.anagNotificationLis.indirizzoResidenza? (data.data.anagNotificationLis.indirizzoResidenza + (data.data.anagNotificationLis.civicoResidenza && true? " " + data.data.anagNotificationLis.civicoResidenza : "")): "",
                    comuneDomicilio:data.data.anagNotificationLis.cittaDomicilio?data.data.anagNotificationLis.cittaDomicilio:data.data.anagNotificationLis.paeseDomicilio,
                    indirizzoDomicilio:data.data.anagNotificationLis.indirizzoDomicilio? (data.data.anagNotificationLis.indirizzoDomicilio + (data.data.anagNotificationLis.civicoDomicilio && true? " " + data.data.anagNotificationLis.civicoDomicilio : "")) : "",
                    formPazienteSpecifico:false,
                    idLisSegnalazione:data.data.id,
                    comuneNascita:data.data.anagNotificationLis.cittaNascita?data.data.anagNotificationLis.cittaNascita:data.data.anagNotificationLis.paeseNascita,
                    infoLaboratorio:'1',
                    tipoLaboratorio:'R',
                    dataEsame:data.data.infoLaboratorio.dttReferto,
                    dataPrelievo:data.data.infoLaboratorio.dttPrelievo,
                    listaDettaglioLab:[data.data.infoLaboratorio.codiceSirmi.split('-')[1]],
                    autore:'LIS',
                    state: { currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI },
                });

                
            }).catch((error) => {
                console.error("Errore durante il recupero della segnalazione:", error);
            });
            sessionStorage.removeItem("parametriRicercaSegnalazioni");
        }

    buildParams(sort, direction, page, size) {
        let params = {
            ulss: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione ||
                SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione ?
                SessioneUtente.getInstance().ulss : null
        }

        params.page = page

        params.order = direction

        params.sort = sort

        params.size = size

        return Utils.removeEmptyValueFromObject(params)
    }

    
    render() {
        console.log("rows " + this.state.rows)
        console.log(">>>>>>>>>>>>>>>>>>>>>>> Operatore_Laboratorio  >>>>>>>>>>>>>>>>>>> " +  Ruoli.Operatore_Laboratorio.descrizione)
        const {t} = this.props;


        return (

            <div className={"container"}>
                {ToasterSingleton.instance().renderToaster()}
                <div style={{display: "flex", justifyContent: "center"}}>
                    {this.controllaUlss() ? <Icon path={this.controllaUlss()}/> :
                        <div style={{marginTop:"5rem"}}/>}
                </div>
                {this.state.loading ?
                    (<div><Spinner/></div>) : (<div/>)}
                <h6>{t("Home.titoloTabella")}</h6>
                <div>
                    <Table cols={this.cols} 
                           rows={this.state.rows}
                           emptyMsg={t("Tables.Home.noSegnalazioni")}
                           lengthEditable={true}
                           totalElements={this.state.totalElements}
                           bigTable={true}
                           homePage={true}
                           totalPages={this.state.totalPages}
                           page={this.state.page}
                           changePage={this.changePageTable}
                           changePagination={this.changePaginationTable}
                    />
                </div>
                <div style={{ marginTop: "-50px" }}>
                    <div
                        style={{
                        border: "1px solid black",
                        height: 15,
                        width: 30,
                        display: "inline-block",
                        backgroundColor: 'rgb(255, 30, 0, 0.3)',
                        marginRight: 5
                        }}
                    />
                    <span>Segnalazione non idonea per invio a premal</span>
                    <br />
                    <div
                        style={{
                        border: "1px solid black",
                        height: 15,
                        width: 30,
                        display: "inline-block",
                        backgroundColor: "#AAD7E6",
                        marginRight: 5
                        }}
                    />
                    Segnalazione integrata con dati notificati da lis
                </div>
                
                {SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Laboratorio.descrizione && globals["notifiche-sirmi-lis"] === "true" && (
                    <div>
                        <h6 style={{ marginTop: "50px" }}>Segnalazioni da LIS</h6>
                        
                        <Table 
                            cols={this.colsLIS} 
                            rows={this.state.rowsLIS}
                            emptyMsg={t("Tables.HomeLIS.noSegnalazioni")}
                            lengthEditable={true}
                            totalElements={this.state.totalElementsLIS}
                            bigTable={true}
                            homePage={true}
                            totalPages={this.state.totalPagesLIS}
                            page={this.state.pageLIS}
                            changePage={this.changePageTableLIS}
                            onButtonSelect={this.inserisciNuova}
                            changePagination={this.changePaginationTableLIS}
                        />
                    </div>
                )}
            </div>
        )

    }
}

export default withTranslation('common')(Home);
